export enum EntityRoles {
  INVOICE_ISSUER = 'issuer',
  INVOICE_ACCEPTOR = 'acceptor',
}
